module.exports = __webpack_public_path__ + "static/media/K-Spades.87e9b093.svg";